// removed by extract-text-webpack-plugin
module.exports = {"container":"lw2cVWQQvUjc-JMt-HKa0","medium":"Tn9I6EHzP0G9H0L50ncQo","large":"_1aLlPUvi6I8DxuUkChlafd"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Field/Text/styles.css
// module id = 3130
// module chunks = 0